import { RootState } from '@/app/redux/store';
import {
  BillingCycle,
  BillingInfo,
  Coupon,
  LicensePlan,
} from '@/common/types/organisation';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UpgradeState {
  // User input
  seatCount: number | null;
  selectedPlan: LicensePlan;
  billingCycle: BillingCycle;
  currency: 'USD' | 'AUD' | 'NZD';
  coupon: Coupon | null;

  // Stripe payment details
  paymentMethod: 'card' | 'invoice';
  clientSecret: string | null;
  confirmationTokenId: string | null;
  billingInfo: BillingInfo | null;
}

const initialState: UpgradeState = {
  seatCount: null,
  selectedPlan: 'small',
  billingCycle: '1year',
  paymentMethod: 'card',
  currency: 'USD',
  coupon: null,

  clientSecret: null,
  confirmationTokenId: null,
  billingInfo: null,
};

const upgradeSlice = createSlice({
  name: 'upgrade',
  initialState,
  reducers: {
    setSeatCount: (state, action: PayloadAction<UpgradeState['seatCount']>) => {
      state.seatCount = action.payload;
    },
    setSelectedPlan: (
      state,
      action: PayloadAction<UpgradeState['selectedPlan']>,
    ) => {
      state.selectedPlan = action.payload;
    },
    setBillingCycle: (
      state,
      action: PayloadAction<UpgradeState['billingCycle']>,
    ) => {
      state.billingCycle = action.payload;
    },
    setPaymentMethod: (
      state,
      action: PayloadAction<UpgradeState['paymentMethod']>,
    ) => {
      state.paymentMethod = action.payload;
    },
    setCurrency: (state, action: PayloadAction<UpgradeState['currency']>) => {
      state.currency = action.payload;
    },
    setCoupon: (state, action: PayloadAction<UpgradeState['coupon']>) => {
      state.coupon = action.payload;
    },
    setClientSecret: (
      state,
      action: PayloadAction<UpgradeState['clientSecret']>,
    ) => {
      state.clientSecret = action.payload;
    },
    setConfirmationToken: (
      state,
      action: PayloadAction<UpgradeState['confirmationTokenId']>,
    ) => {
      state.confirmationTokenId = action.payload;
    },
    setBillingInfo: (
      state,
      action: PayloadAction<UpgradeState['billingInfo']>,
    ) => {
      state.billingInfo = action.payload;
    },
  },
});

export const {
  setSeatCount,
  setSelectedPlan,
  setBillingCycle,
  setPaymentMethod,
  setCurrency,
  setCoupon,
  setClientSecret,
  setConfirmationToken,
  setBillingInfo,
} = upgradeSlice.actions;

export default upgradeSlice.reducer;

export const selectUpgradeState = (state: RootState) => state.upgrade;
